// frontend/src/components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Props:
 * - requirePlatformAdmin: boolean
 * - requirePerm: string (blog-scoped permission, checked via can())
 */
const PrivateRoute = ({ children, requirePlatformAdmin = false, requirePerm = null }) => {
  const { authChecked, isAuthenticated, isPlatformAdmin, can } = useAuth();

  if (!authChecked) return <p>Checking authentication...</p>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Platform admin gate
  if (requirePlatformAdmin && !isPlatformAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Blog-scoped permission gate
  if (requirePerm && typeof can === "function" && !can(requirePerm)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;


